import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import SearchButton from "../../../../components/SearchButton";
import RefreshButton from "../../../../components/RefreshButton";

const TableFilters = ({
  filterText,
  moduleDetails,
  textInputName,
  disabledButton,
}) => {
  const [inputValue, setInputValue] = useState("");

  const FilterData = () => {
    filterText(inputValue);
  };
  const DoNothing = () => {};
  return (
    <div>
      <div className="grid grid-cols-12 space-x-2">
        <div className="col-span-4">
          <TextInput
            type={textInputName}
            name={textInputName}
            value={inputValue}
            placeholder={moduleDetails}
            onChange={(e) => {
              setInputValue(e.target.value);
              e.target.value === "" ? filterText("") : DoNothing();
            }}
          />
        </div>
        <div className="flex flex-row space-x-2">
          <SearchButton
            buttonValue="Search"
            className={
              inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
            }
            disabled={inputValue === "" || disabledButton ? true : false}
            onClick={() => {
              FilterData();
            }}
          />
          <div>
            <RefreshButton
              className={
                inputValue === "" || disabledButton
                  ? "opacity-50"
                  : "opacity-100"
              }
              disabled={inputValue === "" || disabledButton ? true : false}
              onClick={() => {
                if (!disabledButton) {
                  filterText("");
                  setInputValue("");
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default TableFilters;
